// extracted by mini-css-extract-plugin
module.exports = {"blank_parent":"Blank_blank_parent_3iddI"};